module.exports = __webpack_public_path__ + "img/station_icon_green_3.be5a5cb6.svg";